/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "~/backend/axiosClient"
import type {
  FindInformationRequestsForClosureQueryResponse,
  FindInformationRequestsForClosureQueryParams,
} from "../types/FindInformationRequestsForClosure.ts"
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"
import { queryOptions, useQuery } from "@tanstack/react-query"

export const findInformationRequestsForClosureQueryKey = (
  params?: FindInformationRequestsForClosureQueryParams
) =>
  [
    { url: "/v1/traceability-requests/closure-candidates" },
    ...(params ? [params] : []),
  ] as const

export type FindInformationRequestsForClosureQueryKey = ReturnType<
  typeof findInformationRequestsForClosureQueryKey
>

/**
 * @summary Find information requests for closure (supplier portal admin only)
 * {@link /v1/traceability-requests/closure-candidates}
 */
export async function findInformationRequestsForClosure(
  params?: FindInformationRequestsForClosureQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    FindInformationRequestsForClosureQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: "GET",
    url: `/v1/traceability-requests/closure-candidates`,
    params,
    ...requestConfig,
  })
  return res
}

export function findInformationRequestsForClosureQueryOptions(
  params?: FindInformationRequestsForClosureQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const queryKey = findInformationRequestsForClosureQueryKey(params)
  return queryOptions<
    ResponseConfig<FindInformationRequestsForClosureQueryResponse>,
    ResponseErrorConfig<Error>,
    ResponseConfig<FindInformationRequestsForClosureQueryResponse>,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return findInformationRequestsForClosure(params, {
        ...config,
        signal: config.signal ?? signal,
      })
    },
  })
}

/**
 * @summary Find information requests for closure (supplier portal admin only)
 * {@link /v1/traceability-requests/closure-candidates}
 */
export function useFindInformationRequestsForClosure<
  TData = ResponseConfig<FindInformationRequestsForClosureQueryResponse>,
  TQueryData = ResponseConfig<FindInformationRequestsForClosureQueryResponse>,
  TQueryKey extends QueryKey = FindInformationRequestsForClosureQueryKey,
>(
  params?: FindInformationRequestsForClosureQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<FindInformationRequestsForClosureQueryResponse>,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey =
    resolvedOptions?.queryKey ??
    findInformationRequestsForClosureQueryKey(params)

  const query = useQuery(
    {
      ...findInformationRequestsForClosureQueryOptions(params, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
